import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Heading,
  Stack,
} from '@chakra-ui/react';
import PPEResource from 'api/ppe';
import { CenterSpinner } from 'components/common/CenterSpinner';
import CustomTagTitle from 'components/common/CustomTagTitle';
import { strings } from 'config/localization';
import routes from 'constants/routes';
import { PPESchema } from 'constants/schema';
import React from 'react';
import { useQuery } from 'react-query';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { truncateString } from 'utils';
import history from 'utils/history';

const ViewPPE: React.FC = () => {
  const { id }: any = useParams();
  const ppeApi = new PPEResource();

  const ppeQuery = useQuery<PPESchema>(
    [`ppe${id}`, id],
    () => ppeApi.get(id).then((res) => res?.data),
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
    }
  );

  if (ppeQuery.isLoading) {
    return <CenterSpinner />;
  }

  if (ppeQuery.isError) {
    history.push(routes.ppe.list);
  }

  const labelStyles = {
    color: 'gray.900',
    fontWeight: 'bold',
  };
  const infoStyles = {
    color: 'gray.600',
    fontWeight: 'normal',
  };

  return (
    <>
      <Stack direction="column" spacing="4">
        <Breadcrumb color="gray.400" size="4">
          <BreadcrumbItem>
            <BreadcrumbLink as={RouterLink} to={routes.ppe.list}>
              {strings.ppe}
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage color="gray.900">
            <BreadcrumbLink textTransform="capitalize">
              {truncateString(ppeQuery?.data?.name || '')}
            </BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>

        <Flex justify="space-between">
          <Heading size="md" textTransform="capitalize">
            {strings.ppe_details}
          </Heading>
          <Stack direction="row" spacing="6">
            <Button
              size="sm"
              colorScheme="primary"
              onClick={() => history.push(routes.ppe.edit.replace(':id', id))}>
              {strings.edit_ppe}
            </Button>
          </Stack>
        </Flex>

        <Stack bg="white" p={['3', '6']} shadow="box" rounded="sm">
          <Grid
            gap="4"
            templateColumns={['repeat(2, 1fr)', 'repeat(4, 1fr)']}
            w="100%">
            <GridItem>
              <FormControl>
                <FormLabel sx={labelStyles}>{strings.name}</FormLabel>
                <Box sx={infoStyles}>
                  <CustomTagTitle
                    type="text"
                    status={true}
                    name={ppeQuery?.data?.name || '-'}
                  />
                </Box>
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel sx={labelStyles}>{strings.is_mandatory}</FormLabel>
                <Box sx={infoStyles}>
                  {ppeQuery?.data?.is_mandatory ? 'Yes' : 'No'}
                </Box>
              </FormControl>
            </GridItem>
          </Grid>
        </Stack>
      </Stack>
    </>
  );
};

export default ViewPPE;
